import { Fragment, useEffect } from "react";
import { IPage } from "./Components/Page";
import { db } from "./Services/GateKeeperDb";
import { userSettingsStore } from "./Services/UserSettingsStore";


export function menuItem(page: IPage) {
    return <Fragment>
        {page.icon}
        {page.title }
    </Fragment>
}


export function range<T>(a: number, b: number, map: (a: number) => T): T[] {
    const result = [];
    for (let i = a; i <= b; i++)
        result.push(map(i));
    return result;
}

export function useInitAsync(action: () => Promise<any>){
    useEffect(() => {
        action();
    }, []);
}

export async function execAsync<T>(action: () => Promise<T>) {
    return await action();
}
export function formatTime(date: Date): string {
    if (!date)
        return "";
    return date.toLocaleString("IT-it", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit"
    }).replace(",", " ");
}

export function formatDate(date: Date, seconds = false): string {
    if (!date)
        return "";
    return date.toLocaleString("IT-it", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        second: seconds ? "2-digit": undefined
    }).replace(",", " ");
}

export function formatNtcDate(date: Date): string {
    return date.getFullYear() +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        date.getDate().toString().padStart(2, "0") 
}

export function formatNtcTime(date: Date, includeSecs = false): string {
    return date.getHours().toString().padStart(2, "0") +
           date.getMinutes().toString().padStart(2, "0") + 
        (includeSecs ? date.getSeconds().toString().padStart(2, "0") : "");
}
export function generateUUID(){
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
    return uuid;
};


export function isHoneywellDevice() {
    return navigator.userAgent.indexOf("EDA51") != -1 ||
        navigator.userAgent.indexOf("EDA52") != -1;
}

export function loadScriptAsync(src: string) {

    return new Promise<void>((res, rej) => {
        console.debug("LOAD SCRIPT " + src);
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {

            res();
        };
        script.onerror = (er) => {
            console.warn("FAILED SCRIPT " + src, er);
            rej(er);
        }
        document.body.appendChild(script);
    });
}

export function mapObject<TObj extends { [key: string] : any }, K extends keyof TObj, TResult>(obj: TObj, selector: (key: K, value: TObj[K]) => TResult): TResult[] {
    if (!obj)
        return null;
    const result = [] as TResult[];
    for (const key in obj)
        result.push(selector(key as any, obj[key] as any));
    return result;
}

export function sessionStorageProp<T extends object, K extends keyof T & string>(obj: T, name: K) {

    let value: T[K];

    const key = obj.constructor.name + "." + name;
    
    Object.defineProperty(obj, name, {

        get() {
            if (!value) {
                const json = sessionStorage.getItem(key);
                if (json)
                    value = JSON.parse(json);
            }
            return value;
        },
        set(newValue: T[K]) {
            value = newValue;
            sessionStorage.setItem(key, JSON.stringify(value === undefined ? null : value));
        },
        enumerable: true
    });

}

export function parseNtcDate(date?: string | number, time?: string | number) {
    date = typeof (date) == "string" ? date : date.toString();
    time = typeof (time) == "string" ? time : time.toString();

    let year, month, day, hour, minute: number = 0;
    if (date.length == 8) {
        year = parseInt(date.substring(0, 4));
        month = parseInt(date.substring(4, 6));
        day = parseInt(date.substring(6, 8));
    }
    if (time.length == 4) {
        hour = parseInt(time.substring(0, 2));
        minute = parseInt(time.substring(2, 4));
    }

    return new Date(year, month - 1, day, hour, minute);
}

export function formatValidationMessage(msg: string, mode: "long" | "short") {

    if (mode == "long") {

        const timeExp = /(\d\d)H(\d\d)M(\d\d)S/;

        const timeMatch = msg.match(timeExp);
        if (timeMatch) {
            const h = parseInt(timeMatch[1]);
            const m = parseInt(timeMatch[2]);
            const s = parseInt(timeMatch[3]);
            let newValue = "";
            if (h == 0 && m > 0)
                newValue = (m == 1) ? "un minuto" : m + " minuti";
            else if (h == 0 && m == 0)
                newValue = (s == 1) ? "poco" : s + " secondi";
            else if (h < 24)
                newValue = (h == 1) ? "1 ora" : h + " ore";
            else {
                const d = Math.floor(h / 24);
                newValue = (d == 1) ? "1 giorno" : h + " giorni";
            }
            msg = msg.replace(timeExp, newValue);
        }
    }

    if (mode == "short") {
        if (msg.startsWith("Entrato "))
            return "Già entrato";
        if (msg.toLowerCase().indexOf("non in lista") != -1)
            return "Non in lista";
    }

    return msg;
}

export function toCssClass(name: string) {
    return name.toLowerCase().replaceAll(" ", "-");
}

export async function withProfile<T>(action: () => Promise<T>, label: string) {
    const startTime = new Date().getTime();
    const result = await action();
    console.log(label + ": " + ((new Date().getTime() - startTime) / 1000).toFixed(2) + " sec");
    return result;
}

export function getEllapsedTime(from: Date, to: Date) {
    let diff = from.getTime() - to.getTime();
    const isPast = diff >= 0;
    diff = Math.abs(diff);

    const days = Math.floor(diff / (24 * 60 * 60 * 1000));
    const hours = Math.floor(diff / (60 * 60 * 1000));
    const minutes = Math.floor(diff / (60 * 1000));
    const seconds = Math.floor(diff / (1000));

    let msg: string;

    if (days > 0) {
        if (days == 1)
            msg = "un giorno";
        else
            msg = days + " giorni";
    }


    else if (hours > 0) {
        if (hours == 1)
            msg = "un ora";
        else
            msg = hours + " ore";
    }

    else if (minutes > 0) {
        if (minutes == 1)
            msg = "un minuto";
        else
            msg = minutes + " minuti";
    }
    else {
        if (seconds == 1)
            msg = "un secondo";
        else
            msg = seconds + " secondi";
    }

    if (isPast)
        msg += " fa";
    else
        msg = "fra " + msg;

    return msg;
}

export async function execWithCacheAsync<T>(key: string, action: () => Promise<T>, defValue?: T) : Promise<T> {

    try {

        const result = await action();
        await db.cache.put({ key, value: result });
        return result;
    }
    catch (ex) {
        console.warn("execWithCache", ex);
        const cache = await db.cache.get(key);
        if (cache)
            return cache.value;
        if (defValue)
            return defValue;
        throw ex; 
    }
}

export function attachConsole() {

    const realConsole = console;

    console.log("Console Attached");

    window.console = {

        ...realConsole,

        info(...data: any[]) {
            realConsole.info(...data);
            this.write("info", ...data);
        },

        debug(...data: any[]) {
            realConsole.debug(...data);
            this.write("debug", ...data);
        },

        error(...data: any[]) {
            realConsole.error(...data);
            this.write("error", ...data);
        },

        warn(...data: any[]) {
            realConsole.warn(...data);
            this.write("warn", ...data);
        },

        log(...data: any[]) {
            realConsole.log(...data);
            this.write("log", ...data);
        },

        write(className: string, ...data: any[]) {
            const isUserDebug = userSettingsStore.current.debugMode;
            if (!isUserDebug)
                return;
            const myConsole = document.getElementById("console") as HTMLTextAreaElement;
            const line = document.createElement("p");
            line.className = className;
            for (const item of data) {
                if (item === null || item === undefined)
                    continue;
                const lineItem = document.createElement("span");
                lineItem.innerText = item.toString();
                line.appendChild(lineItem);
            }
            myConsole.appendChild(line);
            myConsole.scrollTop = myConsole.scrollHeight;
        }
    } as any;
}

export function setClass(element: HTMLElement, className: string, visible: boolean) {
    const hasClass = element.classList.contains(className);
    if (visible && !hasClass)
        element.classList.add(className);
    else if (!visible && hasClass)
        element.classList.remove(className);
}

export function validateColor(color: string) {

    if (!color || !color.startsWith('#') || color.length != 7)
        return null;
    return color;
}